import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Swallow HTMLMediaElement load/decode errors so a missing/unsupported
// audio or video source never surfaces the CRA dev error overlay.
if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (e) => {
      if (e.target instanceof HTMLMediaElement) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true,
  );
  window.addEventListener("unhandledrejection", (e) => {
    const msg = e?.reason?.message || "";
    const name = e?.reason?.name || "";
    if (
      name === "NotSupportedError" ||
      name === "NotAllowedError" ||
      name === "AbortError" ||
      /supported source|no supported|play\(\)/i.test(msg)
    ) {
      e.preventDefault();
    }
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
